import React from "react";
import Header from "../component/sharedComponents/header";
import CustomIntroSection from "../component/explainBuyPage/customIntroSection";
import FooterUser from "../component/sharedComponents/footer";
import ChooseCategoryTrukeySection from "../component/chooseCategory/ChooseCategoryTrukeySection";
import { useTranslation } from "react-i18next";
const ChooseCategoryPage = () => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col justify-between min-h-screen">
      <Header />
      <div className="mt-[55px] md:mt-[54px] lg:mt-[75px]">
        <CustomIntroSection title={t("customIntro.trukeyStores")} />
      </div>
      <ChooseCategoryTrukeySection />
      <FooterUser />
    </div>
  );
};

export default ChooseCategoryPage;
